export enum CalendarListCategory {
  PAST = "PAST",
  PRESENT = "PRESENT",
  FUTURE = "FUTURE",
}

export interface ICalendar {
  active: boolean;
  id: string;
  isDeactivatable: boolean;
  isDeletable: boolean;
  ownerId: string;
  name: string;
  description?: string;
  year: string;
  excludedDays: IExcludedDay[];
  configurationOptions: {
    absencePlanningEnabled: boolean;
  };
}

export interface INewCalendar
  extends Omit<ICalendar, "id" | "active" | "isDeactivatable" | "isDeletable"> {
  id?: string;
}

export interface IExcludedDay {
  date: string;
  label?: string;
  color?: string;
}

export interface IExcludedWeekDay {
  label: string;
  id: number;
}

export interface ISortedCalendars {
  [year: string]: ICalendar[];
}

export interface ICalendarList {
  [CalendarListCategory.PAST]: ISortedCalendars;
  [CalendarListCategory.PRESENT]: ISortedCalendars;
  [CalendarListCategory.FUTURE]: ISortedCalendars;
}

interface ISortedCalendarsOption {
  id: string;
  label: string;
}

export interface ISortedCalendarsOptions {
  [year: string]: ISortedCalendarsOption[];
}

export enum CalendarAction {
  ADD = "add",
  DELETE = "delete",
}

export interface ICalendarPreviewProps {
  year: string;
  month: number;
  excludedDays: IExcludedDay[];
  excludedWeekDays: number[];
  variant: CalendarPickerVariant;
}

export interface ICalendarPickerProps extends ICalendarPreviewProps {
  handleCalendarDayAction: (action: CalendarAction, day: Date) => void;
}

export enum CalendarPickerVariant {
  PICKER = "picker",
  PREVIEW = "preview",
}

export interface ICalendarStatusArgs {
  calendarId: string;
  active: boolean;
}
